export default [
  {
    path: window.pathApp + '/configuracao-debito-automatico-bb',
    name: 'config.bb',
    component: () => import('@/components/ConfigDebitoBB'),
    meta: {
      login: false,
      avisoCarrinho: false,
      title: "Débito Automático Banco do Brasil",
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/textos.js